import React, { useState} from "react";
import ApiClient from "../services/api-client"
import InvoiceSimpleView from '../components/sales/invoice-simple-view.component';
import { useTranslation } from 'react-i18next';
import BlockUi from '@availity/block-ui';
import { toast } from 'react-toastify';
import useStore from '../hooks/useStore';

export default function AadeSaleSearchByMark() {

    const { t } = useTranslation();
    const [invoice, setInvoice] = useState();
    const [blockuiLoading, setBlockuiLoading] = useState(false);

    const searchOnMydata=()=>{
        setBlockuiLoading(true)
        var mark=document.getElementById("searchByMark").value.trim();
        const companyId = useStore.getState().selectedCompany?.id;

        ApiClient.getTransmittedDoc(companyId,mark).then(
            response => {
                if (response != undefined) {
                    var data=response.data;
                    if (typeof value === 'string') {
                        data=JSON.parse(data);
                    } 
                    if(data.responseType && data.responseType.statusCode=="Failure"){
                        var errors=data.responseType.errors.error;
                        errors.forEach(error => {
                            console.error(error);
                            toast.error(error.message)
                            setBlockuiLoading(false)
                        });
                    }
                    else{
                        var inv;
                        if(data.requestedDoc){
                            inv=data.requestedDoc.invoicesDoc.invoice[0];                           
                        }
                        else{
                            inv=data.invoice;
                        }

                        console.log(inv)
                        setInvoice(inv);
                        setBlockuiLoading(false)
                       
                    }
                }
            },
            error => {
                setBlockuiLoading(false)
                console.error(error.data)
            }
        )
    }

    return (
        <BlockUi tag="div" blocking={blockuiLoading}>
            <div className="container-fluid salesContainer aade-search-page">
                <header className="aade-search-header">
                    <h5 className="subtitle skin mb-0">
                        <i className="fa fa-search" style={{ marginRight: 8 }}></i>
                        {t("searchByMark")}
                    </h5>
                </header>

                <div className="aade-search-bar">
                    <div className="input-group">
                        <input id="searchByMark" placeholder={t('Search')} className="form-control" />
                        <button className="btn btn-skin" onClick={searchOnMydata}>
                            <i className="fa fa-search" style={{ marginRight: 6 }}></i>
                            {t("Search")}
                        </button>
                    </div>
                </div>

                <InvoiceSimpleView invoice={invoice} />
            </div>
        </BlockUi>
    );
}


